module.exports = __webpack_public_path__ + "static/media/onboarding1.48cd02fa.png";